export default "<div class=\"navbar\" id=\"\">\n    ttest\n</div>\n";